module.exports = __webpack_public_path__ + "static/TCP-Logo-1x-a921c182e70c102affa2e4fe99e039c3.png";